import React, {Component, Fragment} from 'react';
import {Col, FormGroup, Label, Input} from 'reactstrap';
import CurrencyInput from 'react-currency-input';

class FormCurrency extends Component {
	render() {
		let displayLabel = this.props.humanLabel;
		if (this.props.dbView) {
			displayLabel = this.props.label;
			if (this.props.parentID) {
				displayLabel = `${this.props.parentID.split('-')[0]}.${this.props.label}`;
			}
		}


		let id = `${this.props.parentID}-${this.props.label}`;
		return (
			<Col xs={this.props.colsize} className={this.props.className}>
				<FormGroup>
					<Label
						className="simpleLabel"
						for={`${this.props.parentID}-${this.props.label}`}
					>
						{displayLabel}{' '}
					</Label>
					<CurrencyInput
						className="rounded-0 textinput form-control"
						onChangeEvent={(_event, _maskedValue, floatValue) => {
							// don't wanto the dollar sign in the db.
							let nextValue = floatValue.toString();
							this.props.triggerFormCurrencyChange(nextValue, id);
						}}
						value={this.props.value}
						id={id}
						prefix="$"
						precision="2"
						allowEmpty={true}
					/>
				</FormGroup>
			</Col>
		);
	}

}

export default FormCurrency;




// WEBPACK FOOTER //
// ./src/components/FormCurrency.js